<script lang="ts" setup>
defineProps<{
  label: string
}>()
</script>

<template>
  <div class="px-4 pb-1 pt-3 text-[10px] font-semibold uppercase tracking-wider text-gray-400 dark:text-gray-500">
    {{ label }}
  </div>
</template>
